import React from "react";
import "./SkeletonLoader.css";

const SkeletonLoader = ({
  type = "card",
  count = 1,
  height = "200px",
  className = "",
}) => {
  const renderSkeleton = () => {
    switch (type) {
      case "card":
        return (
          <div className="skeleton-card">
            <div className="skeleton-header">
              <div className="skeleton-line skeleton-title"></div>
              <div className="skeleton-line skeleton-subtitle"></div>
            </div>
            <div className="skeleton-body">
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
              <div className="skeleton-line skeleton-short"></div>
            </div>
          </div>
        );

      case "chart":
        return (
          <div className="skeleton-chart" style={{ height }}>
            <div className="skeleton-line skeleton-chart-title"></div>
            <div className="skeleton-chart-area">
              <div className="skeleton-chart-bars">
                {[...Array(5)].map((_, i) => (
                  <div
                    key={i}
                    className="skeleton-bar"
                    style={{ height: `${Math.random() * 60 + 20}%` }}
                  ></div>
                ))}
              </div>
            </div>
          </div>
        );

      case "table":
        return (
          <div className="skeleton-table">
            <div className="skeleton-table-header">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="skeleton-line skeleton-th"></div>
              ))}
            </div>
            {[...Array(5)].map((_, rowIndex) => (
              <div key={rowIndex} className="skeleton-table-row">
                {[...Array(4)].map((_, colIndex) => (
                  <div
                    key={colIndex}
                    className="skeleton-line skeleton-td"
                  ></div>
                ))}
              </div>
            ))}
          </div>
        );

      case "text":
        return (
          <div className="skeleton-text">
            <div className="skeleton-line"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-line skeleton-short"></div>
          </div>
        );

      default:
        return (
          <div className="skeleton-default" style={{ height }}>
            <div className="skeleton-line"></div>
          </div>
        );
    }
  };

  return (
    <div className={`skeleton-container ${className}`}>
      {[...Array(count)].map((_, index) => (
        <div key={index} className="skeleton-item">
          {renderSkeleton()}
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
